enum HTMLInputTypeEnum {
  text = 'text',
  email = 'email',
  tel = 'tel',
  date = 'date',
  textarea = 'textarea',
}

export default HTMLInputTypeEnum
